// v2 endpoint registry. Mounted under the `api/v2` node in ./base.js.
// Same declarative shape as ./list.js: { name, url, method } leaves, nested `url` groups.
const listsV2 = [
  { name: "getDeliveries", url: "deliveries", method: "GET" },
  {
    url: "admin",
    children: [{ name: "getDeliveriesAdmin", url: "deliveries", method: "GET" }],
  },
];

export default listsV2;
